module.exports = {
      id: "077b25174328060c8fb7b03b300a4a94kitchenEquipment-electric-stove.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#077b25174328060c8fb7b03b300a4a94kitchenEquipment-electric-stove.svg",
      toString: function () {
        return this.url;
      }
    }